import * as React from 'react';

import type {Textable} from '../types';

import {SelectedButton} from './selected-button';
import {TextableSelectPopover} from './textable-select-popover';

type Props = {
    textables: Textable[];
    selectedTextable: Textable | null | undefined;
    onSelectTextable: (textable: Textable) => void;
    openedFromEntityId: string;
};

export function TextableSelect(props: Props) {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const ref = React.useRef(null);

    return (
        <>
            <SelectedButton
                // @ts-expect-error
                getRef={(node) => (ref.current = node)}
                onClick={() => setIsPopoverOpen(true)}
                selectedTextable={props.selectedTextable}
                // @ts-expect-error
                openedFromEntityId={props.openedFromEntityId}
            />
            {isPopoverOpen && ref && (
                <TextableSelectPopover
                    anchor={ref.current}
                    textables={props.textables}
                    selectedTextable={props.selectedTextable}
                    onSelectTextable={props.onSelectTextable}
                    setIsPopoverOpen={setIsPopoverOpen}
                />
            )}
        </>
    );
}
